<template>
        <img :src="`/${window.location.hostname}/agent.png`">
</template>

<script>
</script>